/**
 * Share and favorite/save buttons for detail pages.
 * Used in the hero sticky header.
 */
import { useTranslation } from "@shared/utils/internationalization";
import Flex, { FlexProps } from "@ui-kit/layout/Flex/Flex.web";
import IconButton from "@ui-kit/form/IconButton/IconButton.web";
import FavoriteHeartButton from "@app-contexts/user/features/favorite-events/components/FavoriteHeartButton/FavoriteHeartButton.web";
import type { FavoriteData } from "../../adapters/types";

interface DetailPageShareAndFavoriteButtonsProps {
  onShareClick: () => void;
  favoriteData?: FavoriteData | null;
  flexProps?: FlexProps;
}

export function DetailPageShareAndFavoriteButtons({
  onShareClick,
  favoriteData,
  flexProps = {},
}: DetailPageShareAndFavoriteButtonsProps) {
  const { t } = useTranslation("purchases");

  return (
    <Flex gap="xs" {...flexProps}>
      <IconButton.Ghost
        iconName="Upload"
        iconColor="fg"
        iconSize="element.xl"
        onClick={onShareClick}
        aria-label={t("Share")}
        data-testid="share-button"
        width="element.2xl"
        height="element.2xl"
        minWidth="element.2xl"
        borderRadius="sm"
        _hover={{
          _light: { bg: "whiteAlpha.400" },
          _dark: { bg: "whiteAlpha.200" },
        }}
      />
      {favoriteData && (
        <FavoriteHeartButton
          favoriteData={favoriteData}
          isAbsolute={false}
          transparent
          showHoverState
        />
      )}
    </Flex>
  );
}
